import CodeTableOptions from 'domain/components/codetable/CodeTableOptions';
import React from 'react';
import { Form, FormGroup, FormLabel } from 'react-bootstrap';

interface ISecurityQuestionInput {
  onQuestionChange: (question: string) => void;
  onAnswerChange: (value: string) => void;
  index: number;
  blacklist: string[];
  question: string;
  answer: string;
  errors: string[];
}

const SecurityQuestionInput = (props: ISecurityQuestionInput) => {
  return (
    <>
      <FormGroup>
        <FormLabel htmlFor={`security-${props.index}-question`}>
          Please select Security Question #{props.index}
        </FormLabel>
        <Form.Control
          as='select'
          id={`security-${props.index}-question`}
          name={`security-${props.index}-question`}
          autoComplete='off'
          onChange={(e) => {
            e.preventDefault();
            const { value } = e.target;
            props.onQuestionChange(value);
          }}
          value={props.question}
          title={props.question}
          isInvalid={props.errors.includes(`s${props.index}q`)}
        >
          <option value=''>- Select -</option>
          <CodeTableOptions
            endpoint='/questions'
            avoidToken
            filter={(o) => !props.blacklist.includes(o.cd)}
          />
        </Form.Control>
        <Form.Control.Feedback type='invalid'>
          Please select a security question.
        </Form.Control.Feedback>
      </FormGroup>
      {(props.answer || props.question) && (
        <FormGroup>
          <FormLabel htmlFor={`security-${props.index}-answer`}>
            Answer to Security Question #{props.index}
          </FormLabel>
          <Form.Control
            id={`security-${props.index}-answer`}
            name={`security-${props.index}-answer`}
            autoComplete='off'
            onChange={(e) => {
              e.preventDefault();
              const { value } = e.target;
              props.onAnswerChange(value);
            }}
            value={props.answer}
            isInvalid={props.errors.includes(`s${props.index}a`)}
          />
          <Form.Control.Feedback type='invalid'>
            Please answer security question.
          </Form.Control.Feedback>
        </FormGroup>
      )}
    </>
  );
};

export default SecurityQuestionInput;
